import React, {useEffect, useState} from 'react';
import {AddIcon, LoadingIcon} from "../../assets/icons/Icons";
import FormSection from "../form/Section";
import FormHeader from "../form/Header";
import Popup from "../Popup";
import { CreateOrder } from "../../api/orders/createOrder";
import ProgramsSelect from "../form/ProgramSelect";
import ShippingAddressSelect from "../form/ShippingAddressSelect";
import CustomSelect from "../form/CustomSelect";
import OfficesSelect from "../form/OfficesSelect";
import {useTranslation} from "react-i18next";
import PackageCodeSelect from "../form/PackageCodeSelect";

const CreateOrderForm = ({onCreate, onClose, ...props}) => {

    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [shippingId, setShippingId] = useState('');
    const [office, setOffice] = useState('');
    const [programId, setProgramId] = useState('');
    const [quantity, setQuantity] = useState('');
    const [code, setCode] = useState('');
    const [submitDisabled, setSubmitDisabled] = useState(true);
    const [fieldErrors, setFieldErrors] = useState([]);

    const [error, setError] = useState('');
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setSubmitDisabled(true);
        try {
            await CreateOrder(firstName, lastName, shippingId, programId, Number(quantity), code, office);
            setLoading(false);
            setSubmitDisabled(false);
            onCreate();
        } catch (err){
            setError(err.message);
            // Only field-level validation errors are an array of {position,message};
            // a 401/500 body is an object, which must not reach FormSection.filter.
            if(Array.isArray(err.data)){
                setFieldErrors(err.data);
            }
            setLoading(false);
            setSubmitDisabled(false);
            console.log("Error fetching data: " + err);
        }
    }

    useEffect(() => {
        if (firstName && lastName && shippingId && programId && quantity && code && office) {
            setSubmitDisabled(false);
        } else {
            setSubmitDisabled(true);
        }
    }, [firstName, lastName, shippingId, programId, quantity, code, office]);

    return (
        <Popup size="large" withClose withOverlay onClose={onClose}>
            <form method="post" onSubmit={handleSubmit}>

                <FormHeader title={t("Create")}></FormHeader>
                <div className="row mb-5 mt-5">
                    <div className="col-xs-6">
                        <FormSection title={t("First Name")} errorPosition={'first_name'} errors={fieldErrors} required>
                            <input type="text" name="first_name" id="first_name" maxLength="30"
                                   placeholder={t("User first name, max 30 characters")} value={firstName}
                                   onChange={e => setFirstName(e.target.value)}/>
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Last Name")} errorPosition={'last_name'} errors={fieldErrors} required>
                            <input type="text" name="last_name" id="last_name" maxLength="30"
                                   placeholder={t("User last name, max 30 characters")} value={lastName}
                                   onChange={e => setLastName(e.target.value)}/>
                        </FormSection>
                    </div>
                </div>
                <div className="row mb-5 mt-5">
                    <div className="col-xs-6">
                        <FormSection title={t("Program ID")} errorPosition={'subprogram_code'} errors={fieldErrors} required>
                            <ProgramsSelect onChange={setProgramId}/>
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Quantity")} errorPosition={'quantity'} errors={fieldErrors} required>
                            <input type="number" name="quantity" id="quantity"
                                   placeholder={t("Choose quantity")} value={quantity}
                                   onChange={ (e) => {
                                       if ( e.target.value >= 0) {
                                           setQuantity(e.target.value)
                                       }
                                   }}
                                   onWheel={(e) => e.target.blur()}
                                   onKeyDown={(e) => { if (e.key === 'ArrowUp' || e.key === 'ArrowDown') e.preventDefault(); }}
                            />
                        </FormSection>
                    </div>
                </div>
                <div className="row mb-5 mt-5">
                    <div className="col-xs-6">
                        <FormSection title={t("Package Code")} errorPosition={'package_code'} errors={fieldErrors} required>
                            <PackageCodeSelect onChange={setCode} programId={programId} isDisabled={!programId}/>
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Office")} required errorPosition={'office_id'} errors={fieldErrors}>
                            <OfficesSelect onChange={setOffice}/>
                        </FormSection>
                    </div>
                </div>
                <div className="row mb-5 mt-5">
                    <div className="col-xs-12">
                        <FormSection title={t("Shipping Address")} required errorPosition={'shipping_address_id'}
                                     errors={fieldErrors}>
                            <ShippingAddressSelect onChange={setShippingId} isDisabled={!office} office={office}/>
                        </FormSection>
                    </div>
                </div>
                <div className="text-right mt-5">
                    <button className={`btn btn-primary btn-medium ${loading ? 'btn-loading' : ''}`} type="submit"
                            name="submit" disabled={submitDisabled}>
                        {loading ? <LoadingIcon/> : <AddIcon/>}
                        {t("Submit")}
                    </button>
                </div>
                {error && <p className="color-error text-center mt-3">{error}</p>}
            </form>
        </Popup>
    );
};

export default CreateOrderForm;